export default __webpack_public_path__ + "static/media/pantry1-afterC-768w.3f88ee0e.png";